<div *ngIf="executionPictures?.length > 0" class="execution-pictures-root">
  <div
    *ngFor="let picture of executionPictures; let i = index"
    class="execution-picture-container"
  >
    <div class="clickable execution-picture" (click)="openLightbox(i)">
      <img [src]="'/api/assets/' + picture.uuid" />
    </div>
  </div>
</div>
